import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { initializeConfiguration as _initializeConfiguration, resetUploadingState as _resetUploadingState } from '../actions/app';
import LoadingOverlay from '../components/LoadingOverlay';
import UploadOptions from './UploadOptions';
import { selectDisplayLegal, selectTermsAndConditionsUrl, selectLoadingIconAttributes, selectSite } from '../selectors/site';
import { TERMS_CONDITIONS_COPY } from '../constants';
import { TermsConditionsContainer } from '../styles';
import { Bounding, Wrapper } from './App.module.css';
export var App = function App(_ref) {
  var initializeConfiguration = _ref.initializeConfiguration,
    resetUploadingState = _ref.resetUploadingState,
    uploading = _ref.uploading,
    headingText = _ref.headingText,
    subheadingText = _ref.subheadingText,
    pasteOnly = _ref.pasteOnly,
    alignText = _ref.alignText,
    displayLegal = _ref.displayLegal,
    termsAndConditionsUrl = _ref.termsAndConditionsUrl,
    loadingIconAttributes = _ref.loadingIconAttributes,
    includeTerms = _ref.includeTerms,
    termsTextColor = _ref.termsTextColor,
    demoTextEnabled = _ref.demoTextEnabled,
    isResubmit = _ref.isResubmit,
    filename = _ref.filename,
    onEnterText = _ref.onEnterText,
    onCtaActivated = _ref.onCtaActivated,
    onCtaClicked = _ref.onCtaClicked,
    onComputerCtaClicked = _ref.onComputerCtaClicked,
    onGoogleDriveCtaClicked = _ref.onGoogleDriveCtaClicked,
    site = _ref.site;
  useEffect(function () {
    if (typeof window !== 'undefined') {
      var _viewName = isResubmit ? 'resubmit your paper widget' : undefined;
      initializeConfiguration(_viewName);

      // this fixes an issue in safari where the page would get cached and not reset the uploading state
      window.onpageshow = function (event) {
        if (event.persisted) {
          resetUploadingState();
        }
      };
    }
  }, []);
  return /*#__PURE__*/React.createElement(Bounding, {
    className: "uw",
    site: site
  }, /*#__PURE__*/React.createElement(Wrapper, {
    className: "uw__wrapper",
    site: site
  }, /*#__PURE__*/React.createElement(LoadingOverlay, {
    displayLegal: displayLegal,
    uploading: uploading,
    iconAttributes: loadingIconAttributes
  }, /*#__PURE__*/React.createElement(UploadOptions, {
    headingText: headingText,
    subheadingText: subheadingText,
    pasteOnly: pasteOnly,
    alignText: alignText,
    onEnterText: onEnterText,
    onCtaActivated: onCtaActivated,
    onCtaClicked: onCtaClicked,
    onComputerCtaClicked: onComputerCtaClicked,
    onGoogleDriveCtaClicked: onGoogleDriveCtaClicked,
    demoTextEnabled: demoTextEnabled,
    isResubmit: isResubmit,
    filename: filename
  }))), includeTerms && !uploading && /*#__PURE__*/React.createElement(TermsConditionsContainer, {
    className: "uw__terms-and-conditions",
    textColor: termsTextColor
  }, /*#__PURE__*/React.createElement("a", {
    href: termsAndConditionsUrl
  }, "*", TERMS_CONDITIONS_COPY)));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    uploading: state.upload.uploading,
    displayLegal: selectDisplayLegal(state),
    termsAndConditionsUrl: selectTermsAndConditionsUrl(state),
    loadingIconAttributes: selectLoadingIconAttributes(state),
    site: selectSite(state)
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    initializeConfiguration: function initializeConfiguration(viewName) {
      return dispatch(_initializeConfiguration(viewName));
    },
    resetUploadingState: function resetUploadingState() {
      return dispatch(_resetUploadingState());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(App);